<template>
    <div>
        <errors v-if="error_messages" :errors="error_messages"></errors>
        <template v-if="success">
            {{ success }}
        </template>
        <form class="c-form js-form-animation" v-if="!success" v-on:submit.prevent="submitForm()">
            <div class="c-field-group">
                <select class="c-select" id="establishment_id" v-model="form.establishment_id" :class="{'valid' : form.establishment_id }">
                    <option v-for="establishment in establishments" :value="establishment.id" >{{ establishment.title }}</option>
                </select>
                <label for="establishment_id" class="c-field-label">{{ translate('db.js.contact.establishment') }}</label>

                <div class="c-field-message is-error" v-if="hasError('establishment_id')">
                    <template v-for="error in getError('establishment_id')">{{ error }}</template>
                </div>
            </div>

            <div class="c-field-group">
                <div class="c-field-wrapper">
                    <select class="c-select" id="subject" v-model="form.subject" :class="{'valid' : form.subject }">
                        <option>{{ translate('frontend.js.contact.select.make_appointment') }}</option>
                        <option>{{ translate('frontend.js.contact.select.change_personal_data') }}</option>
                        <option>{{ translate('frontend.js.contact.select.discontinue') }}</option>
                        <option>{{ translate('frontend.js.contact.select.other_questions') }}</option>
                    </select>
                    <label for="subject" class="c-field-label">{{ translate('db.js.contact.question') }}</label>
                </div>

                <div class="c-field-message is-error" v-if="hasError('subject')">
                    <template v-for="error in getError('subject')">{{ error }}</template>
                </div>
            </div>

            <div class="c-field-group">
                <div class="c-field-wrapper">
                    <input type="text" id="name" class="c-input-text" v-model="form.name" :class="{'valid' : form.name }">
                    <label for="name" class="c-field-label">{{ translate('db.js.global.name') }}</label>
                </div>

                <div class="c-field-message is-error" v-if="hasError('name')">
                    <template v-for="error in getError('name')">{{ error }}</template>
                </div>
            </div>

            <div class="c-field-group">
                <div class="c-field-wrapper">
                    <input type="text" id="email" class="c-input-text" v-model="form.email" :class="{'valid' : form.email }">
                    <label for="email" class="c-field-label">{{ translate('db.js.global.email') }}</label>
                </div>

                <div class="c-field-message is-error" v-if="hasError('email')">
                    <template v-for="error in getError('email')">{{ error }}</template>
                </div>
            </div>

            <div class="c-field-group">
                <div class="c-field-wrapper">
                    <input type="tel" id="phone_number" class="c-input-text" v-model="form.phone_number" :class="{'valid' : form.phone_number }">
                    <label for="phone_number" class="c-field-label">{{ translate('db.js.global.phone') }}</label>
                </div>

                <div class="c-field-message is-error" v-if="hasError('phone_number')">
                    <template v-for="error in getError('phone_number')">{{ error }}</template>
                </div>
            </div>

            <template v-if="form.subject == translate('frontend.js.contact.select.discontinue')">
                <div class="c-field-group">
                    <div class="c-field-wrapper">
                        <input type="text" id="iban" class="c-input-text" v-model="form.iban" :class="{'valid' : form.iban }">
                        <label for="iban" class="c-field-label">{{ translate('db.js.contact.iban') }}</label>
                    </div>

                    <div class="c-field-message is-error" v-if="hasError('iban')">
                        <template v-for="error in getError('iban')">{{ error }}</template>
                    </div>
                </div>

                <div class="c-field-group">
                    <div class="c-field-wrapper">
                        <input type="text" id="box_number" class="c-input-text" v-model="form.box_number" :class="{'valid' : form.box_number }">
                        <label for="box_number" class="c-field-label">{{ translate('db.js.contact.box_number') }}</label>
                    </div>

                    <div class="c-field-message is-error" v-if="hasError('box_number')">
                        <template v-for="error in getError('box_number')">{{ error }}</template>
                    </div>
                </div>
                <div class="c-field-group">
                    <div class="c-field-wrapper">
                        <datetimepicker v-model="form.cancellation_date_at" :format="'d-m-Y'" :timepicker="false" :datepicker="true" classes="c-input-text valid c-input-triangle" :min_date="min_date" :max_date="null" :placeholder="translate('frontend.js.contact.date_placeholder')" :class="{'valid' : form.cancellation_date_at }"></datetimepicker>
                        <label for="cancellation_date_at" class="c-field-label">{{ translate('db.js.contact.cancellation_date_at') }}</label>
                    </div>

                    <div class="c-field-message is-error" v-if="hasError('cancellation_date_at')">
                        <template v-for="error in getError('cancellation_date_at')">{{ error }}</template>
                    </div>
                </div>
            </template>
            <template v-if="form.subject == translate('frontend.js.contact.select.make_appointment')">
                    <div class="c-field-group">
                        <div class="c-field-wrapper">
                            <datetimepicker v-model="form.appointment_at" :format="'d-m-Y H:i'" :timepicker="true" :datepicker="true" classes="c-input-text valid c-input-triangle" :step="30" :disable_weekends="true" :min_date="min_date" :max_date="max_date" :default_date="min_date" :time_options="time_options" :placeholder="translate('frontend.js.contact.date_placeholder')" :class="{'valid' : form.appointment_at }" readonly></datetimepicker>
                            <label for="appointment_at" class="c-field-label">{{ translate('db.js.quotation.appointment_at') }}</label>
                        </div>

                        <div class="c-field-message is-error" v-if="hasError('appointment_at')">
                            <template v-for="error in getError('appointment_at')">{{ error }}</template>
                        </div>
                    </div>
            </template>
            <div class="c-field-group">
                <div class="c-field-wrapper">
                    <textarea class="c-text-area" type="text-area" id="message" v-model="form.message" :class="{'valid' : form.message }"></textarea>
                    <label for="message" class="c-field-label">{{ translate('db.js.global.message') }}</label>
                </div>
                
                <div class="c-field-message is-error" v-if="hasError('message')">
                    <template v-for="error in getError('message')">{{ error }}</template>
                </div>
            </div>

            <div class="c-checkbox-wrapper">
                <input class="c-checkbox" type="checkbox" id="terms" name="terms" v-model="form.is_gdpr">
                <label for="terms" class="c-checkbox-label" :class="{'error' : hasError('is_gdpr')}" v-html="translate('frontend.js.global.agree_terms', {'privacy_statement_url' : '/privacybeleid' })"></label>

                <div class="c-field-message is-error" v-if="hasError('is_gdpr')">
                    <template v-for="error in getError('is_gdpr')">{{ error }}</template>
                </div>
            </div>

            <vue-recaptcha :sitekey="this.sitekey" v-on:verify="onCaptchaVerified" v-on:expired="onCaptchaExpired"></vue-recaptcha>

            <button type="submit" class="button" :disabled="disable_submit">{{ translate('frontend.js.global.send') }}</button> 
        </form>
    </div>
</template>
<script>
    import Vue              from 'vue';
    import VueRecaptcha     from 'vue-recaptcha';
    import Errors           from '../ui/errors';
    import Success          from '../ui/success';
    import DateTimePicker   from '../fields/datetimepicker';

    export default {
        name: 'contact',
        props: ['establishment'],
        data() {
            return {
                sitekey: '6Ldbu80UAAAAACsG_VLWVEBmSPDYSMa3M_uYgDKp',
                form: {
                    establishment_id: null,
                },
                establishments: [],
                error_messages: null,
                errors: null,
                success: null,
                disable_submit: false,
                min_date: new Date().toISOString().split('T')[0],
                max_date: null,
                time_options: [],
            }
        },
        components: {
            'vue-recaptcha' : VueRecaptcha,
            'errors'        : Errors,
            'success'       : Success,
            'datetimepicker': DateTimePicker,
        },
        mounted() {
            this.getFormData();
            this.setDateTimePickerValues();
        },
        methods: {
            /**
             * Get the form data from the api
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            getFormData() {
                axios.all([
                    axios.get('/api/establishments'),
                ]).then(axios.spread(this.setFormData));
            },

            /**
             * Set the form data that is relevant for the form
             * 
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  establishments
             * @return void
             */
            setFormData(establishments) {
                this.establishments = establishments.data;
                this.pickRelevantEstablishment();
                let vm = this;
                this.$nextTick(function() {
                    Vue.set(vm.form, 'subject', Lang.get('frontend.js.contact.select.make_appointment'));
                });
            },

            /**
             * Pick a relevant establishment
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            pickRelevantEstablishment() {
                if(this.establishment) {
                    this.form.establishment_id = this.establishment;
                }
            },

            /**
             * Submit the form with form data
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            submitForm() {
                this.disable_submit = true;
                this.error_messages = null;

                if(!this.checkIfRecaptchaVerified()) {
                    return false;
                }

                if(this.form.subject !== Lang.get('frontend.js.contact.select.discontinue')) {
                    this.form.iban = null;
                    this.form.box_number = null;
                    this.form.cancellation_date_at = null;
                }
                if(this.form.subject !== Lang.get('frontend.js.contact.select.make_appointment')){
                    this.form.appointment_at = null;
                }

                axios.post('/api/contact-request', this.form)
                .then(this.successFullyPosted)
                .catch(this.catchErrors);
            },

            /**
             * Set form.recaptcha when Recaptcha is verified
             * 
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  response
             */
            onCaptchaVerified(response) {
                this.form.recaptcha = response;
            },

            /**
             * Empty form.recaptcha when Recaptcha is expired
             *
             * @author Robin van Leeuwen <robin@click.nl>
             */
            onCaptchaExpired() {
                this.form.recaptcha = null;
            },

            /**
             * Check if Recaptcha is verified before submitting the form
             * 
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            checkIfRecaptchaVerified() {
                if (!this.form.recaptcha) {
                    this.error_messages = Lang.get('frontend.js.global.recaptcha_error');
                    this.disable_submit = false;
                    return false; // prevent form from submitting
                }
                return true;
            },

            /**
             * After the form successfully posted
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  response
             * @return void
             */
            successFullyPosted(response) {
                this.success = response.data.message;
                this.disable_submit = false;
            },

            /**
             * Catch the errors from the form submit
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  error
             * @return void
             */
            catchErrors(error) {
                this.disable_submit = false;
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.error_messages = Lang.get('frontend.js.global.422_error');
                } else {
                    this.error_messages = Lang.get('frontend.js.global.error');
                }
            },

            /**
             * Check wether the form field has an error
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  string field
             * @return boolean
             */
            hasError(field) {
                return this.errors && this.errors[field] && this.errors[field].length > 0;
            },

            /**
             * Get the error from the field
             * 
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  string field
             * @return string
             */
            getError(field) {
                return this.errors[field][0];
            },

            /**
             * Set values for DateTimePicker
             * @author Bas Lokerman <bas@click.nl>
             */
            setDateTimePickerValues() {
                var current_date = new Date();
                current_date.setDate(current_date.getDate() + 1);
                var day = current_date.getDate();
                var month = current_date.getMonth() + 1;
                var year = current_date.getFullYear();
                var max_year = current_date.getFullYear() + 1;
                this.min_date = day + '-' + month + '-' + year;

                this.max_date = day + '-' + month + '-' + max_year;

                this.time_options = [
                    '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00',
                ];
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/contact/contact-form.vue